import React, {Component} from 'react'

import Registry from '../../../registry/index';

import {ROOM_TYPE_PERSONAL} from "../../../constants/rooms";

class ChatLogItemExclusionApplied extends Component {
    render() {
        let lang = Registry.get('locale');

        let {message: user, currentRoomInfo} = this.props;

        return (
            <div className="exclusion-applied-notification">
                {currentRoomInfo.type !== ROOM_TYPE_PERSONAL ? lang.block_user_excluded(user) : lang.block_user_excluded_personal(user)}
            </div>
        )
    }

}

export default ChatLogItemExclusionApplied;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatLogItemExclusionApplied/index.js